import {
  FETCH_DIVISIONS_SUCCESS
} from '../actions/divisionActions';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_DIVISIONS_SUCCESS:
      return action.divisions;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/divisionsReducer.js